"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.StyledSlidingModal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = _interopRequireDefault(require("../Icons/obsolete/index"));

var StyledSlidingModal = _styledComponents.default.div.withConfig({
  displayName: "StyledSlidingModal",
  componentId: "sc-1l295ko-0"
})(["position:relative;min-height:4rem;z-index:2001;background-color:white;display:flex;flex-direction:column;width:100%;max-width:100%;height:100%;justify-content:flex-start;"]);

exports.StyledSlidingModal = StyledSlidingModal;
StyledSlidingModal.DismissButton = _styledComponents.default.button.withConfig({
  displayName: "DismissButton",
  componentId: "sc-1l295ko-1"
})(["position:absolute;top:0;left:-2rem;width:2rem;height:2rem;cursor:pointer;display:flex;justify-content:center;align-items:center;background:#2e5299;border:none;"]);
StyledSlidingModal.CloseIcon = (0, _styledComponents.default)(_index.default.Cross).attrs({
  color: "#FFF"
}).withConfig({
  displayName: "CloseIcon",
  componentId: "sc-1l295ko-2"
})(["overflow:visible;"]);